import React from "react";
import PropTypes from "prop-types";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faClock } from "@fortawesome/free-solid-svg-icons"; // solid version
import styles from "./ComingSoonComponent.module.css";

const ComingSoonComponent = ({ message }) => (
  <div className={styles.ComingSoonComponent}>
    <div className="pp-section">
      <div className="card surfaceCard text-center py-5">
        <div className="card-body d-flex flex-column align-items-center gap-3">
          <div className={styles.iconWrap}>
            <FontAwesomeIcon icon={faClock} size="lg" />
          </div>
          <h2 className="h5 fw-semibold mb-1">Coming Soon</h2>
          <p className="text-secondary mb-0">
            {message || "We’re still building this feature. Check back later!"}
          </p>
        </div>
      </div>
    </div>
  </div>
);

ComingSoonComponent.propTypes = {
  /** Optional custom message under the title */
  message: PropTypes.string,
};

ComingSoonComponent.defaultProps = {
  message: "",
};

export default ComingSoonComponent;
